import { TESTIMONIAL } from '../types';

export default {
  state: {
    testimonialQuery: null,
  },
  getters: {},
  mutations: {
    [TESTIMONIAL.SET_TESTIMONIAL_QUERY](state, payload) {
      state.testimonialQuery = payload;
    },
  },
  actions: {},
};
